import { createApp, defineComponent } from 'vue';
import GridCostCellEditor from './GridCostCellEditor.vue';
import customHelper from '$$helpers/custom';
import globalToast from '$$vueCmp/toast';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridCostCellEditor);

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder);
      vueInstance = vueApp.mount(placeholder);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, id, column, node) {
      vueInstance.value = task.total_price;
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, id, column, node) {
      return task.total_price !== vueInstance.value;
    },

    is_valid(value, id, column, node) {
      if (!customHelper.testNumber(value)) {
        globalToast.warning(__('grid_number_custom_column_not_valid'));

        return false;
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const value = vueInstance.value.toString().replace(',', '.');

      task.total_price = +value;
      instance.updateTask(task.id);
      instance.refreshData(); // recalculate parents
    },

    focus(node) {
    },
  };
}
